export default __webpack_public_path__ + "static/media/rocket_anim_136.cb08c3ac.png";